<div class="container-fluid mb-2 h-100">
    <div class="row">
        <div class="col-12 mt-2">
            <mat-tab-group mat-align-tabs="start" (selectedTabChange)="tabChanged($event)">
              <mat-tab label="Nova">
                <cadastro-grupo-carteira [edit]="false" #cadastroGrupoCarteira></cadastro-grupo-carteira>
              </mat-tab>
              <mat-tab label="Importação em lote">
                <app-importacao-lote [tipo]="tipo" (onBaixarModelo)="downloadModelo()" #grupoCarteiraImportacaoLote></app-importacao-lote>
              </mat-tab>
              <mat-tab label="Gerenciar registros">
                <gerenciador-registros #gerenciadorRegistros></gerenciador-registros>
              </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
